import {
  DialogTrigger,
  GhostIconButton,
  Popover,
  PopoverContent,
  Text,
} from "@certn/cascadia-react";
import React from "react";

interface CoApplicant {
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
}

interface CoSigner {
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
}

interface Props {
  coApplicants?: CoApplicant[] | null;
  coSigners?: CoSigner[] | null;
}

export function CoApplicantsTooltip({ coApplicants, coSigners }: Props) {
  const hasData =
    (coApplicants && coApplicants.length > 0) ||
    (coSigners && coSigners.length > 0);

  if (!hasData) {
    return "--";
  }

  return (
    <DialogTrigger>
      <GhostIconButton
        icon="group"
        size="small"
        aria-label="Co-applicants and guarantors"
      />
      <Popover placement="top">
        <PopoverContent>
          <div style={{ maxWidth: "250px", padding: "8px" }}>
            {coApplicants && coApplicants.length > 0 && (
              <div style={{ marginBottom: "8px" }}>
                <Text style="global/body-secondary">
                  <b>Co-applicants:</b>
                </Text>
                <ul style={{ margin: "4px 0", paddingLeft: "16px" }}>
                  {coApplicants.map((coApplicant, index) => (
                    <li key={index}>
                      <Text style="global/body-secondary">
                        {[coApplicant.first_name, coApplicant.last_name]
                          .filter(Boolean)
                          .join(" ") || "Unknown"}
                      </Text>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {coSigners && coSigners.length > 0 && (
              <div>
                <Text style="global/body-primary">
                  <b>Guarantor:</b>
                </Text>
                <ul style={{ margin: "4px 0", paddingLeft: "16px" }}>
                  {coSigners.map((coSigner, index) => (
                    <li key={index}>
                      <Text style="global/body-secondary">
                        {[coSigner.first_name, coSigner.last_name]
                          .filter(Boolean)
                          .join(" ") || "Unknown"}
                      </Text>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </PopoverContent>
      </Popover>
    </DialogTrigger>
  );
}
